// src/constants/constants.ts
export const FUEL_OPTIONS = [
  'E',
  '1/16',
  '1/8',
  '3/16',
  '1/4',
  '5/16',
  '3/8',
  '7/16',
  '1/2',
  '9/16',
  '5/8',
  '11/16',
  '3/4',
  '13/16',
  '7/8',
  '15/16',
  'F'
] as const;

export const FUEL_LEVEL_MAP = {
  'E': 0,
  '1/16': 0.0625,
  '1/8': 0.125,
  '3/16': 0.1875,
  '1/4': 0.25,
  '5/16': 0.3125,
  '3/8': 0.375,
  '7/16': 0.4375,
  '1/2': 0.5,
  '9/16': 0.5625,
  '5/8': 0.625,
  '11/16': 0.6875,
  '3/4': 0.75,
  '13/16': 0.8125,
  '7/8': 0.875,
  '15/16': 0.9375,
  'F': 1
} as const;

// Temperature constants
export const TEMPERATURE_CONSTANTS = {
  // Temperature thresholds for health checks (in Celsius)
  THRESHOLDS: {
    EXCELLENT: { returnSupply: 0.5, setpointReturn: 1 },
    GOOD: { returnSupply: 1.5, setpointReturn: 2 },
    WARNING: { returnSupply: 3, setpointReturn: 4 },
    CRITICAL: { returnSupply: 5, setpointReturn: 6 }
  },
  
  // Validation thresholds
  VALIDATION: {
    SETPOINT_DISCREPANCY: 0.5, // Celsius
    OUT_OF_RANGE: 2.5 // Celsius
  },
  
  // Temperature conversion constants
  CONVERSION: {
    FAHRENHEIT_MULTIPLIER: 9/5,
    FAHRENHEIT_OFFSET: 32,
    CELSIUS_MULTIPLIER: 5/9
  }
} as const;

// UI constants
export const UI_CONSTANTS = {
  // Toast notification lifetimes (milliseconds)
  TOAST_LIFE: {
    SHORT: 3000,
    MEDIUM: 5000,
    LONG: 8000
  },
  
  // Polling intervals (milliseconds)
  POLLING: {
    ACTIVE_TIME_RECORDS: 90000, // 90 seconds
    GENERAL_REFRESH: 120000 // 2 minutes
  },
  
  // Component sizes and dimensions
  LAYOUT: {
    COLUMN_WIDTHS: {
      TYPE: 100,
      DESCRIPTION: 150,
      TIME: 80,
      ACTIONS: 50
    },
    SCROLL_HEIGHT: '200px',
    MAX_SELECTED_LABELS: 2
  }
} as const;

// Equipment type codes
export const EQUIPMENT_TYPES = {
  ELECTRIC: 0,
  DIESEL: 1
} as const;

// Unit states
export const UNIT_STATES = {
  OFF: 'OFF',
  DEAD: 'DEAD',
  RUNNING: 'RUNNING'
} as const;

// Common alarm and issue options
export const COMMON_ISSUES = [
  'Tripped Unit CB',
  'Tripped Gen Receptacle CB (ESL)',
  'Tripped Gen Int CB',
  'BO Male Plug (ext cord)',
  'BO Female Conn (ext cord)',
  'BO Unit Male Plug',
  'BO Splice (unit cord)',
  'BO Splice (ext cord)'
] as const;

export const UNIT_MANUFACTURERS = [
  'Carrier Primeline',
  'Carrier Thinline',
  'Carrier Eliteline',
  'Thermo-King',
  'Daikin Zestia',
  'Starcool'
] as const;
